export default __webpack_public_path__ + "static/media/cotedazur.849cbed8.jpg";